import React from 'react';
import { Card, Table } from 'antd';
import { formatMoney } from '@/utils/format';

export interface EpcEstimateCommercialBoqTableProps {
  buckets: Array<{
    key: string;
    code?: string;
    name?: string;
    line_count?: number;
    total_amount?: number;
    client_amount?: number;
    sell_amount?: number;
    margin_pct?: number | null;
    schedule_vs_cost_delta?: number;
    coverage_status?: string;
  }>;
  loading?: boolean;
  onSelectBoq?: (boqLineId: string) => void;
}

/**
 * EST3 UX3 Wave 5 — BOQ-level sell / margin / cost table.
 */
export const EpcEstimateCommercialBoqTable: React.FC<EpcEstimateCommercialBoqTableProps> = ({
  buckets,
  loading,
  onSelectBoq,
}) => (
  <Card size="small" title="BOQ commercial view">
    <Table
      size="small"
      rowKey="key"
      loading={loading}
      dataSource={buckets.filter((b) => b.key !== '_unallocated')}
      pagination={buckets.length > 50 ? { pageSize: 50 } : false}
      scroll={{ x: true }}
      onRow={(row) => ({
        onClick: () => row.key && onSelectBoq?.(row.key),
        style: { cursor: onSelectBoq ? 'pointer' : undefined },
      })}
      columns={[
        { title: 'Item', dataIndex: 'code', width: 100 },
        { title: 'Description', dataIndex: 'name', ellipsis: true },
        {
          title: 'Schedule',
          dataIndex: 'client_amount',
          width: 100,
          render: (v) => formatMoney(v, { display: 'plain', maximumFractionDigits: 0 }),
        },
        {
          title: 'Cost',
          dataIndex: 'total_amount',
          width: 100,
          render: (v) => formatMoney(v, { display: 'plain', maximumFractionDigits: 0 }),
        },
        {
          title: 'Sell',
          dataIndex: 'sell_amount',
          width: 100,
          render: (v) => formatMoney(v, { display: 'plain', maximumFractionDigits: 0 }),
        },
        {
          title: 'Margin',
          dataIndex: 'margin_pct',
          width: 72,
          render: (v) => (v != null ? `${v}%` : '—'),
        },
        {
          title: 'Δ Sched-Cost',
          dataIndex: 'schedule_vs_cost_delta',
          width: 100,
          render: (v) => formatMoney(v, { display: 'plain', maximumFractionDigits: 0 }),
        },
        { title: 'Links', dataIndex: 'line_count', width: 56 },
      ]}
    />
  </Card>
);
